


































import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { IPersonalInfo } from '@/componentsV2/templates/Modals/InviteMerchantSignup/PersonalInfo/EditPersonalInfo.vue';
import eventBus from '@/utils/eventBus';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    Typography
  }
})
export default class PersonalInfo extends Vue {
  @Prop() code!: string;
  @Prop() managerName!: string;
  @Prop() managerLastName!: string;
  @Prop({ default: 'email-name@provider.com' }) managerMail!: string;

  get fullName() {
    return `${this.managerName} ${this.managerLastName}`;
  }

  handleEditPersonalInfo() {
    segmentIo.track('Clicked on Edit Personal Info (Ownership experience)');
    this.editPersonalInfo();
  }

  editPersonalInfo() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'editPersonalInfo',
        hideCancelButton: true,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        code: this.code,
        initialData: {
          managerName: this.managerName,
          managerLastName: this.managerLastName,
          managerMail: this.managerMail
        },
        onSuccess: (newValue: IPersonalInfo) => {
          eventBus.$emit('reloadInviteBusinessInfo');
          this.$notification('Changes saved successfully!', 'success');
        }
      }
    );
  }
}
